import React, { useContext } from "react"
import PropTypes from "prop-types"
import Floor from "./Floor"

import "./styles.less"
import { SpaceProfileContext } from "../context"

const SpaceLayout = ({
  spProfile = {},
  queryString,
  selectedSpaceId,
  selectedSpaceType,
  user,
  optionText = false,
  bundledSpace = false,
  displayPrice,
}) => {
  // const spaceSummary = qs.parse(queryString)

  const {
    commonData: { filteredOptionsByFloor, spaceSummary },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  // const [, setSvgs] = useState();

  if (filteredOptionsByFloor.length === 0) {
    return null
  }

  return (
    <div className="space-profile-layout pb-0 pt-0 pt-md-3">
      <div className={"row"}>
        <div className={"col-sm-12"}>
          {filteredOptionsByFloor.map((floor, idx) => (
            <Floor
              key={idx}
              svg={floor.map_svg_url || floor.plan_svg}
              bg={floor.map_background_url || floor.plan_bg}
              spaces={floor.items}
              spaceSummary={spaceSummary}
              user={user}
              optionText={optionText}
              displayPrice={displayPrice}
              optionStart={
                idx > 0 ? filteredOptionsByFloor[idx - 1].items.length : 0
              }
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default SpaceLayout

SpaceLayout.propTypes = {
  spProfile: PropTypes.object,
  queryString: PropTypes.string,
  activeModal: PropTypes.string,
  setActiveModal: PropTypes.func,
  index: PropTypes.string,
  selectedSpaceType: PropTypes.string,
  selectedSpaceId: PropTypes.string,
}
